module.exports = __webpack_public_path__ + "img/TrojanFilms01.9f7710e7.jpeg";